<div class="left">
    <div class="userinfo full nomtops">
        <div class="basicrow m-bott">
            <div class="basicrow f-bmed roboto-b m-bott">
                Detalle del Plan
            </div>
            <div class="autorow roboto-r pull-right">
                {{this.currentPlan}}
            </div>
        </div>
        <div class="basicrow m-top-ii">
            <div class="basicrow f-reg roboto-b m-bott">
                Descripci&oacute;n del Plan:
            </div>
            <div class="descripcion-plan" [innerHtml]="descr_plan"></div>
        </div>
    </div>
</div>
<div class="right">
    <div class="basicrow text-center">
        <div class="servs-monthly planchg">
            <div class="basicrow">
                <span class="roboto-b">
              Precio<br>
                </span><br>
                <span class="f-red f-semi roboto-m">
              {{this.actualPrice | currency}}
                </span>
            </div>
        </div>
    </div>
</div>